<template>
  <div class="nomNavMargin" :class="!landPC?'showNav':''">
    <!-- <div class="header" @click="ycCodeData"> -->
    <div class="header">
      <Header />
    </div>
    <div class="content-container">
      <router-view />
    </div>
    <div class="footer">
      <Footer />
      <PartnerForm></PartnerForm>
    </div>
    <PhoneAndBack/>
    <BackTop/>
    <alertext></alertext>
  </div>
</template>
<script>
// import {mapState} from 'vuex';
import Header from 'components/HomePageHeaderNav'
import Footer from 'components/HomePageFooter'
import PhoneAndBack from "components/PhoneAndBack"
import PartnerForm from "components/PartnerForm"
import BackTop from "components/BackTop"
import alertext from "components/alertext"
import Bus from '../../config/bus'

export default {
  name: 'index',
  data() {
    return {
      // navMargin: 'nomNavMargin'
      landPC:true
    };
  },
  mounted() {
    Bus.$on('pageY', (val) => {
      this.navMargin =　val >= 4322 ? 'rgznNavMargin' : 'nomNavMargin';　
    })
    Bus.$on('landPCdisapperar', (val) => {
      console.log(val)
      this.landPC=val
    })
    Bus.$on('landPCdisapperar', (val) => {
      console.log(val)
      this.landPC=val
    })
    this.landPagePCdisapearNav();
  },
  methods: {
     ycCodeData(){
       Bus.$emit('codeIndex', "");
     },
      landPagePCdisapearNav(){
      let path=this.$route.path
      if(path=="/landingPage"){
        Bus.$emit("landPCdisapperar",false)
        Bus.$emit("footdisapperar",false)
      }else{
        Bus.$emit("footdisapperar",true)
      }
    },
  },
  components: {
    Header, Footer,PhoneAndBack,BackTop,PartnerForm,alertext
  },
  watch:{
}
};
</script>
<style scoped>
   @media screen and (min-width: 998px) {
     /* 导航优化需求 导航栏改成fiexd定位 每个页面给外边距 */
     .nomNavMargin{
       /* padding-top: 8.74458vw; */
       /* 2.86458  */
       padding-top: 4.1vw;
     }
     .showNav{
       padding-top: 0;
     }
   }
   @media screen and (max-width: 998px){
     /* .nomNavMargin{
       padding-top: 13.8667vw;
     } */
      .showNav{
       padding-top: 0;
     }
      .wrapContainer{
       display: none;
     }
   }

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue